import { FrontendUploadFileHandle } from "src/api/generated/common/frontendUploadFileHandle";
import { ManagedFileHandle } from "src/api/generated/common/managedFiles/managedFileHandle";
import { makeAxiosRequest } from "src/api/utils/apiClient.ts";

export const uploadFile = async (file: File): Promise<FrontendUploadFileHandle> => {
	return (await uploadFiles([file]))[0]!;
};

export const uploadFiles = async (files: File[]): Promise<FrontendUploadFileHandle[]> => {
	if (files.length === 0) return [];

	const formData = new FormData();
	files.forEach((file, index) => {
		formData.append(`file${index}`, file);
	});

	const response = await makeAxiosRequest<FileUploadResponse>({
		url: "/api/files/cache/upload",
		method: "PUT",
		headers: {
			"Content-Type": "multipart/form-data"
		},
		data: formData
	});

	return response.cacheFileNames.map((cacheFileName) => ({
		fullFileName: cacheFileName
	}));
};

/** Uploads a managed file that only the uploading user can claim, and returns its ID. */
export const uploadManagedFile = async (file: File): Promise<number> => {
	const formData = new FormData();
	formData.append("file", file);
	const response = await makeAxiosRequest<ManagedFileHandle[]>({
		url: "/api/files/managed/upload",
		method: "PUT",
		headers: {
			"Content-Type": "multipart/form-data"
		},
		data: formData
	});
	return response[0]!.managedFileId;
};

/** Stages managed files that only the uploading user can use until an operation claims them. */
export const uploadManagedFiles = async (files: File[]): Promise<ManagedFileHandle[]> => {
	if (files.length === 0) return [];

	const formData = new FormData();
	files.forEach((file, index) => {
		formData.append(`file${index}`, file);
	});

	const handles = await makeAxiosRequest<ManagedFileHandle[]>({
		url: "/api/files/managed/upload",
		method: "PUT",
		headers: {
			"Content-Type": "multipart/form-data"
		},
		data: formData
	});
	if (handles.length !== files.length) throw new Error("The managed file upload did not return every file.");
	return handles;
};

interface FileUploadResponse {
	cacheFileNames: string[];
}
